import * as React from "react";
const SvgList20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M14 5H6v2h8V5Zm0 4H6v2h8V9Zm-8 4h8v2H6v-2Z"
    }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 1h16v18H2V1Zm2 2h12v14H4V3Z",
      clipRule: "evenodd"
    })
  );
export default SvgList20Px;
